import React from "react";
import { Icon } from "antd";

import Image from "../Image";
import Span from "../Span";

const mapper = {
  bold: "bold"
};

function classNameMapper(key) {
  return mapper[key];
}

export default function(type, props = {}, cellData, rowData) {
  switch (type) {
    case "image":
      return image(cellData, props);
    // case "clickable":
    //   return clickable(cellData, rowData, props);
    case "text":
    default:
      return text(cellData, props);
  }
}

function image(data, props = {}) {
  const className = getClassName(data ? "cell-image" : "cell-icon", props);
  return data ? (
    <Image className={className} src={data} {...props} />
  ) : (
    <Icon className={className} type="picture" {...props} />
  );
}

function text(data, props = {}) {
  const className = getClassName("", props);
  return (
    <Span {...props} className={className}>
      {data}
    </Span>
  );
}

function getClassName(className = "", props = {}) {
  let result = "";
  if (props.color) result = result.concat(`${props.color} `);
  if (props.bold) result = result.concat(`${classNameMapper("bold")} `);
  return result && className
    ? className.concat(` ${result.substr(0, result.length - 1)}`)
    : result
    ? result
    : className;
}



// WEBPACK FOOTER //
// ./src/components/ui-ant/Datatable/renderers.js